<div container>
  <div
    class="hcp__headline__container d-flex align-items-center justify-content-lg-center"
  >
    <div class="headline-text-box">
      <h2 class="mb-0">HCP resources</h2>
    </div>
  </div>
  <div class="hcp__cards__container justify-content-center mx-auto mb-4">
    <div class="card card--purple bg-white d-flex flex-column">
      <div class="card__image card__image--4 flex-shrink-0 align-self-center">
        <picture
          [data]="{
          image: 'resources/question-icon',
          webp: false,
          altext: 'A question mark',
          format: '',
          width: '104',
          height: '104',
          mobile: false,
          classes: 'img-fluid'
        }"
        ></picture>
      </div>
      <div class="card__text-box d-flex flex-column flex-grow-1">
        <div>
          <h3 class="text-center text-lg-start">
            Screening brochures for patients
          </h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Want to provide your patients with more information? Share our
            screening guides for both adult and pediatric patients, downloadable
            below.
          </p>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0">
          <div
            class=""
            global-button
            [buttonData]="{
              buttonLabel: 'Download',
              buttonUrl: '/assets/pdf/type-1-diabetes-patient-screening-brochures.pdf',
              openInNewTab: true,
              buttonIcon: 'download-icon',
              interstitial: false
            }"
          ></div>
        </div>
      </div>
    </div>



    <!-- <div class="card card--orange bg-white d-flex flex-column">
      <div class="card__image card__image--5 flex-shrink-0 align-self-center">
        <picture
          [data]="{
          image: 'resources/group-of-people',
          webp: false,
          altext: 'A family tree',
          format: '',
          width: '113',
          height: '113',
          mobile: false,
          classes: 'img-fluid'
        }"
        ></picture>
      </div>
      <div class="card__text-box d-flex flex-column flex-grow-1">
        <div>
          <h3 class="text-center text-lg-start">
            Pediatric Screening Considerations
          </h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Learn how proactive T1D screening can support earlier detection in
            pediatric patients—and practical steps to identify and screen this
            vulnerable patient population.
          </p>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0">
          <div
            class=""
            global-button
            [buttonData]="{
              buttonLabel: 'Download',
              buttonUrl: '/assets/pdf/type-1-diabetes-screening-protocol-checklist.pdf',
              openInNewTab: true,
              buttonIcon: 'download-icon',
              interstitial: false
            }"
          ></div>
        </div>
      </div>
    </div> -->

    <!-- <div class="card card--yellow bg-white d-flex flex-column">
      <div class="card__image card__image--6 flex-shrink-0 align-self-center">
        <picture
          [data]="{
            image: 'resources/doctors',
          webp: false,
          altext: 'A care team',
          format: '',
          width: '256',
          height: '136',
          mobile: false,
          classes: 'img-fluid'
        }"
        ></picture>
      </div>
      <div class="card__text-box d-flex flex-column flex-grow-1">
        <div>
          <h3 class="text-center text-lg-start">
            Adult Screening Considerations
          </h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Explore why T1D screening matters in high-risk adults, recognize
            risk factors for misclassification, and identify practical steps to
            screen at-risk patients.
          </p>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0">
          <div
            class=""
            global-button
            [buttonData]="{
              buttonLabel: 'Download',
              buttonUrl: '/assets/pdf/type-1-diabetes-screening-protocol-checklist.pdf',
              openInNewTab: true,
              buttonIcon: 'download-icon',
              interstitial: false
            }"
          ></div>
        </div>
      </div>
    </div> -->
    <div class="card card--aqua bg-white d-flex flex-column">
      <div class="card__image card__image--1 flex-shrink-0 align-self-center">
        <picture
          [data]="{
          image: 'resources/note-icon-resources',
          webp: false,
          altext: 'A clipboard and a vial',
          format: '',
          width: '100',
          height: '126',
          mobile: false,
          classes: 'img-fluid'
        }"
        ></picture>
      </div>
      <div class="card__text-box d-flex flex-column flex-grow-1">
        <div>
          <h3 class="text-center text-lg-start">Screening Codes for HCPs</h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Want to learn about insurance billing codes? We've got you covered.
            We've compiled a list below for easy reference in the office.
          </p>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0">
          <div
            class=""
            global-button
            [buttonData]="{
              buttonLabel: 'Download',
              buttonUrl: '/assets/pdf/type-1-diabetes-screening-codes-for-hcps.pdf',
              openInNewTab: true,
              buttonIcon: 'download-icon',
              interstitial: false
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <div class="hcp__cards__container justify-content-center mx-auto">
    <div class="card card--yellow bg-white d-flex flex-column">
      <div class="card__image card__image--2 flex-shrink-0 align-self-center">
        <picture
          [data]="{
            image: 'resources/migni-icon-resources',
          webp: false,
          altext: 'A magnifying glass looking at a droplet',
          format: '',
          width: '93',
          height: '103',
          mobile: false,
          classes: 'img-fluid'
        }"
        ></picture>
      </div>
      <div class="card__text-box d-flex flex-column flex-grow-1">
        <div>
          <h3 class="text-center text-lg-start">
            There's a BETAWAY to Look at T1D
          </h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Looking for a deeper dive into the world of beta cells and their
            critical role in the patient journey? Check out
            <a
              href="https://www.betawayt1d.com/"
              target="_blank"
              class="text-primary text-decoration-none"
              >betawayt1d.com</a
            >
            to learn more
          </p>
        </div>
        <div class="card--2__button mt-auto mx-auto mx-lg-0">
          <div
            global-button
            [buttonData]="{
              buttonLabel: 'Visit',
              buttonUrl: 'https://www.betawayt1d.com/',
              openInNewTab: true,
              buttonIcon: 'right-icon',
              interstitial: true
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="card card--orange bg-white d-flex flex-column">
      <div class="card__image card__image--1 flex-shrink-0 align-self-center">
        <picture
          [data]="{
          image: 'resources/cells',
          webp: false,
          altext: 'A cluster of cells',
          format: '',
          width: '100',
          height: '126',
          mobile: false,
          classes: 'img-fluid'
        }"
        ></picture>
      </div>
      <div class="card__text-box d-flex flex-column flex-grow-1">
        <div>
          <h3 class="text-center text-lg-start">
            T1D Screening and Early Detection Checklist
          </h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Not sure where to start? Explore a step-by-step approach to
            establishing T1D screening, outreach, and referral pathways within
            your practice.
          </p>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0">
          <div
            class=""
            global-button
            [buttonData]="{
              buttonLabel: 'Download',
              buttonUrl: '/assets/pdf/type-1-diabetes-screening-protocol-checklist.pdf',
              openInNewTab: true,
              buttonIcon: 'download-icon',
              interstitial: false
            }"
          ></div>
        </div>
      </div>
    </div>
   
  </div>
</div>
